import React from 'react';
import ConditionActions from './ConditionActions';
import ConditionStatus from './ConditionStatus';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { openDialog, setDialogMode, showErrorMessage, updateCondition } from '../../../redux/slices/condition';
import { CONDITION_STATUS } from '../../../constants';
import type { UpdateConditionParams } from '../../../types/condition';

const ConditionStatusAction = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);

  const handleRequestApproval = (): void => {
    dispatch(setDialogMode('REQUEST_APPROVAL'));
    dispatch(openDialog());
  };

  const handleWithdrawEditing = (): void => {
    if (condition) {
      const params: UpdateConditionParams = {
        conditionStatus: CONDITION_STATUS.APPROVED,
      };
      dispatch(updateCondition(condition.id, params));
    } else {
      dispatch(showErrorMessage('対象の可視制御が選択されていません'));
    }
  };

  const handleWithdrawRequest = (): void => {
    if (condition) {
      const params: UpdateConditionParams = {
        conditionStatus: CONDITION_STATUS.EDITING,
        applicantId: '',
      };
      dispatch(updateCondition(condition.id, params));
    } else {
      dispatch(showErrorMessage('対象の可視制御が選択されていません'));
    }
  };

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <ConditionActions
        condition={condition}
        selectedViewMode={selectedViewMode}
        onRequestApproval={handleRequestApproval}
        onWithdrawEditing={handleWithdrawEditing}
        onWithdrawRequest={handleWithdrawRequest}
      />
      <ConditionStatus condition={condition} />
    </>
  );
};

export default ConditionStatusAction;
